import React from "react";

const CustomerUnit = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">Our Commitment</h5>
            <p className="text-dark opacity-50">
              At Topcoin UK, we are committed to protecting the value and
              security of every customer’s TopCoin and cash rewards earned
              through purchases at participating businesses. We provide a
              three-layer protection system to ensure that both TopCoin and cash
              balances are safeguarded within the Topcoin UK ecosystem.
            </p>
            <h5 className="title_text text-dark">
              1. Company-Backed System Assurance (Internal Safeguarding)
            </h5>
            <p className="text-dark opacity-50">TopCoin UK ensures that:</p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                All TopCoin balances and reward records are securely stored
                within the TopCoin UK system.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className=" text-dark opacity-75"
              >
                TopCoin balances are maintained within the platform and cannot
                be adjusted without valid system action.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                TopCoin balances are maintained within the platform and cannot
                be adjusted without valid system action.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                If a technical system error occurs, TopCoin UK will review the
                issue and may correct affected balances based on verified
                internal records.
              </li>
            </ul>

            <p className="text-dark opacity-50">
              This assurance relates to platform functionality only and is not
              financial insurance, financial protection, or an FCA-regulated
              guarantee.
            </p>
          </div>
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              2. TopCoin UK System Reserve (Platform Stability Support)
            </h5>
            <p className="text-dark opacity-50">
              {" "}
              TopCoin UK maintains a dedicated internal reserve to support system integrity. This reserve is designed to:
            </p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Support system continuity in rare cases of technical malfunction.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Assist with resolving verified TopCoin balance discrepancies caused by internal system failures.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Provide ope
              </li>
            </ul>
          </div>
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              3. Operational Protection (Business Continuity & Security)
            </h5>
            <p className="text-dark opacity-50">
              {" "}
             TopCoin UK maintains strong operational safeguards to protect our systems, data, and user accounts. This includes:
            </p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Secure cloud infrastructure and server protection
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >Regular data backup and cybersecurity protection measures- Data backup and cybersecurity insurance.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Internal fraud prevention controls and operational continuity safeguards
              </li>
            </ul>
            <h5 className="text-dark">Immediate Access to Cash Rewards</h5>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Customers may withdraw eligible cash rewards in line with TopCoin UK’s terms and conditions.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                Milestones and levels are designed to enhance the loyalty experience but are not required to keep your TopCoin balance.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                This ensures customers always retain flexible access to their rewards within the TopCoin UK ecosystem.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                In the unlikely event of a system issue, balances will be restored using verified internal records.
              </li>
            </ul>
            <h5 className="text-dark">Legal Classification</h5>

            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                TopCoin UK rewards are loyalty rewards, not financial products or investments.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                TopCoin is not tradable, not a cryptocurrency, and not an investment instrument.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                All cash rewards are funded by TopCoin UK’s advertising and business participation system — not customer deposits and not investments.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="text-dark opacity-75"
              >
                This policy does not constitute financial insurance, and TopCoin UK does not require FCA regulation, as the system operates as a loyalty and rewards programme.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerUnit;
